module.exports = __webpack_public_path__ + "img/mask_layer_pc@2x.fb99bebf.png";